import { Modal, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

export default function CompRgstrdFormSubmitted({ show, onClose, redirectLink }) {
    const navigate = useNavigate();

    return (
        <Modal
            open={show} 
            onClose={() => {
                onClose();
                navigate(redirectLink);
            }}
            aria-labelledby="Co"
            aria-describedby="modal-modal-description"
        >
            <Wrapper className='d-flex flex-column align-items-center justify-content-center gap-3'>
                <img src="/Images/success.png" alt="success" className='w-25 mx-auto' />
                <h2 className='text-center'> Submitted Successfully </h2>
                {/* <p className='text-center w-90'> Form Submitted Successfully For Company/Producy Registraion, you will notifed when then compnay/product gets approved by our team. </p> */}
                <Link to={redirectLink}>
                    <Button size='large' variant='text' className='px-4 py-2'> View Companies </Button>
                </Link>
            </Wrapper>
        </Modal>
    );
}

const Wrapper = styled.div`
    width: 600px;
    min-height: 500px;
    padding: 35px 50px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: var(--bg-color);
    border-radius: 20px;
    button{
        background: var(--secondary-light);
        color: var(--secondary-color);
        &:hover{
            background: var(--secondary-color);
            color: white;
        }
    }
`;
